import { useId } from 'react';
import { SelectField, type SelectFieldOption } from '@humanforce/mango-ui-react';

// Mango's `SelectField` renders no internal label (unlike `TextField`), so we pair it with an
// associated <label> and optional error text. This keeps dropdowns labelled and accessible
// (getByLabelText) and gives them the same critical/error treatment as other form fields.
//
// Named MangoSelectField (not SelectField) to avoid colliding with the shared, native-<select>
// `components/ui/SelectField`; this one wraps the richer @humanforce/mango-ui-react `SelectField`.
interface MangoSelectFieldProps {
  label: string;
  value: string;
  options: SelectFieldOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  id?: string;
}

export const MangoSelectField = ({ label, value, options, onChange, placeholder, required, disabled, error, id }: MangoSelectFieldProps) => {
  const generatedId = useId();
  const fieldId = id ?? generatedId;
  return (
    <div className="mgo-stack mgo-gap-xs">
      <SelectField
        id={fieldId}
        label={label}
        value={value}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        invalid={Boolean(error)}
        required={required}
        onChange={(next) => onChange(String(next ?? ''))}
      />
      {error && <span className="mgo-text-xs mgo-color-critical" role="alert">{error}</span>}
    </div>
  );
};
